import { Navigate, useParams } from "../../../../../router-utils"

export default function WhatsAppIntegrationOverviewPage() {
	const { integrationId } = useParams("/integrations/:integrationId/whatsapp")
	return (
		<Navigate
			to="/integrations/:integrationId/whatsapp/templates"
			params={{ integrationId }}
			replace
		/>
	)
}
